(() => {
  const button = document.querySelector('[data-back-to-top]');
  if (!button) return;

  const toggleVisibility = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    button.classList.toggle('is-visible', scrollTop > 0);
  };

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', toggleVisibility, { passive: true });
  toggleVisibility();
})();
